import React from 'react';
import { isEmpty } from 'ramda';
import { SurveyInstance } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';
import RenderSidebar from './Sidebars/renderer';

interface SurveyElements {
  name: string;
  colCount?: number;
  rows?: number;
  type: string;
  title?: string;
  placeHolder?: string;
  isRequired?: boolean;
  choices?: string[];
}

interface SurveyWithPages {
  [key: string]: any;
}

interface SurveyBriefingProps {
  json: SurveyWithPages | undefined;
  initialValues?: { [key: string]: any };
  onComplete?: (surveyData: object) => any;
  onPageChanged?: () => void;
  mode?: 'edit' | 'display';
  isSinglePage?: boolean;
  hasSummaryPage?: boolean;
  locale?: string;
  summaryClass?: any;
  isBexioUser: boolean;
  briefingSlug?: string;
  isBrandValuatorProduct: boolean;
  withRouteObserver?: boolean;
  insights?: any[];
  orgCodename?: string;
}

function SurveyBriefing({
  json,
  onComplete,
  onPageChanged,
  initialValues = {},
  mode = 'edit',
  isSinglePage = false,
  hasSummaryPage = false,
  locale,
  summaryClass,
  briefingSlug,
  isBexioUser,
  isBrandValuatorProduct,
  withRouteObserver,
  insights,
  orgCodename,
}: SurveyBriefingProps) {
  const t = useFormatMessage();

  if (isEmpty(json) || typeof json === 'undefined') {
    return null;
  }
  const HandleOnComplete = (data: any) =>
    typeof onComplete !== 'undefined' ? onComplete(data) : undefined;

  const customStrings = {
    completingSurvey: t(
      'survey.completeBrefieng',
      'Thanks for completing the briefing!'
    ),
    pagePrevText: t(`survey.pagePrevtext`, 'Back'),
  };

  return (
    <SurveyInstance
      json={json}
      isSinglePage={isSinglePage}
      onCurrentPageChanged={onPageChanged}
      fixedNavigation={false}
      showProgressBar="top"
      locale={locale}
      mode={mode}
      withRouteObserver={withRouteObserver}
      hasSummaryPage={hasSummaryPage}
      initialValues={isBexioUser ? { Bdiscount_on_plan: true } : initialValues}
      customStrings={customStrings}
      showCompletedPage={false}
      onComplete={(survey: any) => HandleOnComplete(survey.data)}
      summaryClass={summaryClass}
      summaryComponent={
        !isBrandValuatorProduct ? (
          <RenderSidebar
            briefingSlug={briefingSlug}
            locale={locale}
            insights={insights}
            orgCodename={orgCodename}
          />
        ) : null
      }
    />
  );
}

const checkPropsEquality = (
  prevProps: SurveyBriefingProps,
  nextProps: SurveyBriefingProps
) => {
  const stringifiedPrevProps = JSON.stringify(prevProps);
  const stringifiedNextProps = JSON.stringify(nextProps);
  const arePropsEqual = stringifiedPrevProps === stringifiedNextProps;

  return arePropsEqual;
};

const MemoizedComponent = React.memo(SurveyBriefing, checkPropsEquality);

export default MemoizedComponent;
